import React, { useCallback } from 'react';
import { Carousel } from '@shared/components/ui/carousel';
import { BalanceCard } from './BalanceCard';
import { AddBalanceCard } from './AddBalanceCard';
import type { BalanceCardsSectionProps } from './types';

export const BalanceCardsSection: React.FC<BalanceCardsSectionProps> = ({
  balances = [],
  showAddCard = true,
  onAddBalance,
  onBalanceAction,
  className,
  addCardTitle = "Add new balance",
  addCardDescription = "Create a new balance\naccount for your funds"
}) => {
  const handleAddNewBalance = useCallback(() => {
    onAddBalance?.();
  }, [onAddBalance]);

  const handleBalanceAction = useCallback((action: string, balanceId: string) => {
    onBalanceAction?.(action, balanceId);
  }, [onBalanceAction]);

  return (
    <Carousel
      className={`w-full mb-6 ${className || ''}`}
      itemWidth="280px"
      gap="1rem"
      showNavigation
    >
      {/* Balance Cards */}
      {balances.map((balance) => (
        <BalanceCard
          key={balance.id}
          balance={balance}
          onAction={handleBalanceAction}
        />
      ))}
      
      {/* Add Balance Card */}
      {showAddCard && (
        <AddBalanceCard
          onAddBalance={handleAddNewBalance}
          title={addCardTitle}
          description={addCardDescription}
        />
      )}
    </Carousel>
  );
};